"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/createStyles/createStyles.js
 ** module id = 410
 ** module chunks = 0
 **/